/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Interests } from '../../models/interests';

export interface UpdateInterest$Params {
  profileId: string;
  id: string;
      body?: Interests
}

export function updateInterest(http: HttpClient, rootUrl: string, params: UpdateInterest$Params, context?: HttpContext): Observable<StrictHttpResponse<Interests>> {
  const rb = new RequestBuilder(rootUrl, updateInterest.PATH, 'put');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Interests>;
    })
  );
}

updateInterest.PATH = '/studentprofile/{profileId}/interests/{id}';
